import { Unauthorized } from "./Unauthorized";
import { UserPermissions } from "../models/UserPermissions";
import { useHasAnyPermission } from "../hooks/useHasAnyPermission";
import { ReactNode } from "react";

interface PermissionGuardProps {
  children: ReactNode | ReactNode[];
  permissions: UserPermissions | UserPermissions[];
}

export const PermissionGuard = ({
  children,
  permissions,
}: PermissionGuardProps) => {
  const allowed = useHasAnyPermission(permissions);

  return allowed ? (
    <>{children}</>
  ) : (
    <Unauthorized/>
  );
};
